import { jsx as n } from "react/jsx-runtime";
import { forwardRef as v } from "react";
import k from "./ImageCardCore.js";
import { classes as x } from "../../utils/helpers.js";
import '../../assets/ImageCard.css';const l = {
  "image-card--clickable": "_image-card--clickable_1b3j4_13",
  "image-card__img-wrapper": "_image-card__img-wrapper_1b3j4_17",
  "image-card--inline": "_image-card--inline_1b3j4_35",
  "image-card__image": "_image-card__image_1b3j4_39",
  "image-card__mobile-image": "_image-card__mobile-image_1b3j4_45",
  "image-card__play-icon": "_image-card__play-icon_1b3j4_77",
  "play-icon__triangle": "_play-icon__triangle_1b3j4_93",
  "image-card__content": "_image-card__content_1b3j4_112",
  "image-card__cta-wrapper": "_image-card__cta-wrapper_1b3j4_133",
  "image-card__cta": "_image-card__cta_1b3j4_133",
  "image-card__overlay-content": "_image-card__overlay-content_1b3j4_147"
}, L = v(function(_, o) {
  const {
    image: t = { url: "", altText: "", aspectRatio: 1, sources: [] },
    mobileImage: d = { url: "", altText: "", aspectRatio: 1 },
    fullSizeImagePosition: a = [50, 50],
    mobileImagePosition: r = [50, 50],
    clampContentLines: p = !0,
    numberOfLinesToClamp: s = 3,
    overlayPosition: g = "left",
    overlayTextColor: m = "#fff",
    relatedResourceId: j = "",
    cta: e = {
      label: "",
      href: "",
      type: "",
      relatedResourceId: "",
      relatedResourceType: "",
      position: "end"
    },
    handleClicks: C = () => {
    },
    fullCardClickable: c = !1,
    displayInline: i = !1,
    classname: y = ""
  } = _, u = /* @__PURE__ */ new Map([
    ["left", "flex-start"],
    ["right", "flex-end"],
    ["center", "center"]
  ]), f = (b) => {
    C({
      type: "card-clicked",
      ctaType: e == null ? void 0 : e.type,
      resourceId: j,
      resourceType: e.relatedResourceType,
      target: b.target,
      currentTarget: b.currentTarget
    });
  };
  return c && (e == null ? void 0 : e.href) !== "" && ((e == null ? void 0 : e.type) === "internal-link" || (e == null ? void 0 : e.type) === "external-link") ? /* @__PURE__ */ n(
    "image-card",
    {
      class: x([
        c ? l["image-card--clickable"] : null,
        i ? l["image-card--inline"] : null,
        y
      ]),
      style: {
        "--justify-overlay-content": u.get(g),
        "--align-overlay-content": i ? "center" : "flex-end",
        "--overlay-content-text-color": m,
        "--content-line-clamp": p ? s : "unset",
        "--image-aspect-ratio": t.aspectRatio,
        "--mobile-image-aspect-ratio": d.aspectRatio,
        "--background-image-position": `${(a == null ? void 0 : a[0]) ?? "50"}% ${(a == null ? void 0 : a[1]) ?? "50"}%`,
        "--mobile-background-image-position": `${(r == null ? void 0 : r[0]) ?? "50"}% ${(r == null ? void 0 : r[1]) ?? "50"}%`
      },
      onClick: c ? f : () => !0,
      "data-cursor": "pointer",
      children: /* @__PURE__ */ n(
        "a",
        {
          href: e.href,
          title: t == null ? void 0 : t.altText,
          target: e.type === "external-link" ? "_blank" : "_self",
          rel: e.type === "external-link" ? "noreferrer" : null,
          className: "image-card__full-card-link",
          children: /* @__PURE__ */ n(k, { ..._, styles: l, ref: o })
        }
      )
    }
  ) : /* @__PURE__ */ n(
    "image-card",
    {
      class: x([
        i ? l["image-card--inline"] : null,
        y
      ]),
      style: {
        "--justify-overlay-content": u.get(g),
        "--align-overlay-content": i ? "center" : "flex-end",
        "--overlay-content-text-color": m,
        "--content-line-clamp": p ? s : "unset",
        "--image-aspect-ratio": t.aspectRatio,
        "--mobile-image-aspect-ratio": d.aspectRatio,
        "--background-image-position": `${(a == null ? void 0 : a[0]) ?? "50"}% ${(a == null ? void 0 : a[1]) ?? "50"}%`,
        "--mobile-background-image-position": `${(r == null ? void 0 : r[0]) ?? "50"}% ${(r == null ? void 0 : r[1]) ?? "50"}%`
      },
      onClick: c ? f : () => !0,
      "data-cursor": c ? "pointer" : "default",
      children: /* @__PURE__ */ n(k, { ..._, styles: l, ref: o })
    }
  );
});
export {
  L as ImageCard,
  L as default
};
